import React from 'react';
import { motion } from 'framer-motion';
//import { Store, Package, ArrowLeft } from 'lucide-react';
import Button from '../ui/button';

export default function OrderTypeSelector({ onSelect, onBack }) {
  return (
    <div className="h-screen flex flex-col bg-white overflow-x-hidden">
      {/* Header */}
      <div className="flex items-center md:p-6 xs:p-6 p-4">
        <Button
          variant="default"
          size="back"
          onClick={onBack}
          className="text-gray-600"
        >
          <img src="/images/back.png" alt="back" className="lg:w-[100px] lg:h-[100px] md:w-[80px] md:h-[80px] sm:w-[60px] sm:h-[60px] w-[40px] h-[40px] mt-3 ml-2 rounded-[12px] " />
        </Button>
      </div>
      <main className="flex-1 flex items-center justify-center md:px-8 px-4">
        <div className="flex flex-col gap-12 items-center w-full max-w-[1400px] -mt-32">
          <div className=" font-outfit lg:text-[100px] md:text-[80px] sm:text-[60px] text-[40px] font-medium text-center text-boonsdarkbg whitespace-nowrap">Select Order Type</div>
          {/* Options */}
          <div className="flex w-full md:gap-12 gap-6 items-stretch justify-center  p-4">
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => onSelect('dinein')}
              className="max-w-[600px] max-w-[600px] max-h-[350px] md:max-h-none flex-1 bg-boonsOrange  rounded-[20px] text-white md:p-12 p-6 flex flex-col items-center justify-center "
            >
              {/* <Store className="w-32 h-32" /> */}
              <div className="lg:text-3xl md:text-5xl sm:text-[80px] text-xl font-outfit font-medium mb-4 text-center">
                <img src="/images/dine-in.png" alt="dinein" className="lg:w-[230px] lg:h-[230px] md:w-[120px] md:h-[120px] w-[60px] h-[60px] mt-3 ml-2 rounded-[12px]" />
              </div>
              <div className="lg:text-[54px] md:text-[54px] sm:text-[54px] text-xl  mb-4  font-outfit font-medium leading-[80px] tracking-[0px] text-center">
                DINE-IN
              </div>
            </motion.button>

            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => onSelect('takeaway')}
              className="max-w-[600px] max-h-[350px] md:max-h-none flex-1 bg-boonsdarkbg rounded-[20px] text-white md:p-12 p-6 flex flex-col items-center justify-center "
            >
              <div className="lg:text-3xl md:text-5xl sm:text-[80px] text-xl font-outfit font-medium mb-4  text-center">
                <img src="/images/take-away.png" alt="takeaway" className="lg:w-[230px] lg:h-[230px] md:w-[120px] md:h-[120px] w-[60px] h-[60px] mt-3 ml-2 rounded-[12px]" />
              </div>
              <div className="lg:text-[54px] md:text-[54px] sm:text-[54px] text-xl  mb-4  font-outfit font-medium leading-[80px] tracking-[0px] text-center">
                TAKE-OUT
                {/* <p className="text-2xl opacity-90">Grab and go</p> */}
              </div>
            </motion.button>
          </div>
        </div>
      </main>
    </div>
  );
}